<div class="page-header">
    <div class="row align-items-center">
        <div class="col">
            <h3 class="page-title">SEO Settings</h3>
            <ul class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/dashboard">Dashboard</a></li>
                <li class="breadcrumb-item active">SEO Settings</li>
            </ul>
        </div>
    </div>
</div>

<div class="row" *ngIf="!loading">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <form (ngSubmit)="submit()">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Web Title Override</label>
                                <input type="text" class="form-control" name="web_title" [(ngModel)]="data.web_title"
                                    placeholder="Default browser tab title">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Meta Keywords</label>
                                <input type="text" class="form-control" name="meta_keywords"
                                    [(ngModel)]="data.meta_keywords" placeholder="keyword1, keyword2, keyword3">
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Meta Description</label>
                                <textarea class="form-control" name="meta_description"
                                    [(ngModel)]="data.meta_description" rows="3"
                                    placeholder="Description for search engines and social sharing"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Open Graph (OG) Image</label>
                                <app-image-uploader #ogImageUploader
                                    (onUpload)="upload($event, 'og_image', true)"></app-image-uploader>
                                <small class="text-muted">Recommended size: 1200x630px for social previews.</small>
                            </div>
                        </div>
                    </div>

                    <div class="text-right">
                        <button type="submit" class="btn btn-primary">Save Changes</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="text-center" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>